// nextRfiNumber — the next sequential RFI reference for a project.
// ─────────────────────────────────────────────────────────────────────────────
// RFIs are auto-numbered per project, zero-padded to three digits: 001, 002, …
// We take the highest number already in use and add one, so the sequence is
// stable even after deletions (we never reuse a gap) and a brand-new project
// starts at 001.
//
// Each existing rfiNo/id is parsed by its TRAILING digits, which covers the
// common schemes ("001", "RFI-001", "RFI 12", "2024-001"). Timestamp-style
// fallbacks left by older code (e.g. "RFI-1718900000000") are ignored via the
// sane-ceiling guard so they can't poison the sequence.
//
// Pass the project's RFI list (App.js already scopes `rfis` to the selected
// project). Both the form's live preview and the save handler call this with the
// same list, so the number shown is the number written.
export function nextRfiNumber(rfis = []) {
  const maxInUse = (rfis || []).reduce((max, rfi) => {
    const match = String(rfi?.rfiNo || rfi?.id || "").match(/(\d+)\s*$/);
    if (!match) return max;
    const value = parseInt(match[1], 10);
    return Number.isFinite(value) && value < 100000 && value > max ? value : max;
  }, 0);
  return String(maxInUse + 1).padStart(3, "0");
}
